import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./pin-anchor-feedback-section.module.scss";
import { AnchorPositioningFeedback } from "../../../../state/pin-anchor-state";
import IconVelavuFeedback from "../../../../dynamicicons/icon-velavu-feedback";
import VelavuNotice, {
	VelavuNoticeType,
} from "../../../../elements/velavu-notice/velavu-notice";
import { makeStyleable } from "../../../../helper/icon-helper";
import IconInfo from "../../../../dynamicicons/icon-info";
import { classArr } from "../../../../helper/style-helper";

export interface PinAnchorFeedbackSectionProps {
	className?: string;
	feedback: AnchorPositioningFeedback;
}

interface FeedbackContent {
	noticeType: VelavuNoticeType;
	title: string;
	subtitle: string;
}

export default function PinAnchorFeedbackSection(
	props: PinAnchorFeedbackSectionProps,
) {
	const { t } = useTranslation();

	const content = useMemo((): FeedbackContent => {
		switch (props.feedback) {
			case AnchorPositioningFeedback.Close:
				return {
					noticeType: "warning",
					title: t(
						"dashboard.pin_anchor.feedback.not_efficient_title",
					),
					subtitle: t(
						"dashboard.pin_anchor.feedback.not_efficient_subtitle",
					),
				};
			case AnchorPositioningFeedback.OK:
				return {
					noticeType: "confirm",
					title: t("dashboard.pin_anchor.feedback.good_title"),
					subtitle: t("dashboard.pin_anchor.feedback.good_subtitle"),
				};
			case AnchorPositioningFeedback.Far:
				return {
					noticeType: "error",
					title: t(
						"dashboard.pin_anchor.feedback.out_of_reach_title",
					),
					subtitle: t(
						"dashboard.pin_anchor.feedback.out_of_reach_subtitle",
					),
				};
			case AnchorPositioningFeedback.NoSite:
				return {
					noticeType: "error",
					title: t(
						"dashboard.pin_anchor.feedback.outside_site_title",
					),
					subtitle: t(
						"dashboard.pin_anchor.feedback.outside_site_subtitle",
					),
				};
		}
	}, [props.feedback, t]);

	return (
		<div className={classArr(props.className, styles.container)}>
			<div className={styles.header}>
				<IconVelavuFeedback color="currentColor" size={32} />

				<span>{t("dashboard.pin_anchor.feedback.header")}</span>
			</div>

			<div className={styles.body}>
				<VelavuNotice
					type={content.noticeType}
					icon={makeStyleable(IconInfo)}
				>
					{content.title}
				</VelavuNotice>

				<span>{content.subtitle}</span>
			</div>
		</div>
	);
}
